<ion-input
  labelPlacement="floating"
  [label]="showLabel ? ('repetition.plural' | translate) : undefined"
  *ngIf="valueType === 'repetitions'"
  fill="outline"
  [min]="min"
  [placeholder]="placeholder"
  autocomplete="off"
  type="number"
  [formControl]="formCtrl"
  autocomplete="off"></ion-input>


<ng-container *ngIf="valueType === 'interval'">
  <me-time-input-cell [formControl]="formCtrl" mode='ion-input'></me-time-input-cell>
</ng-container>
